import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Projects from "@/pages/Projects";
import WorkItems from "@/pages/WorkItems";
import Discovery from "@/pages/Discovery";
import SiteLogs from "@/pages/SiteLogs";
import Puantaj from "@/pages/Puantaj";
import MaterialRequests from "@/pages/MaterialRequests";
import MaterialMovements from "@/pages/MaterialMovements";
import ProgressPayments from "@/pages/ProgressPayments";
import Documents from "@/pages/Documents";
import Firms from "@/pages/Firms";
import Analytics from "@/pages/Analytics";
import DataImport from "@/pages/DataImport";
import ItemMatching from "@/pages/ItemMatching";
import Deductions from "@/pages/Deductions";
import Landing from "@/pages/Landing";
import { getCompany } from "@/lib/api";
import Contracts from "@/pages/Contracts";
import ContractDetail from "@/pages/ContractDetail";
import { Toaster } from "@/components/ui/sonner";

const TkcOnly = ({ children }) => (getCompany() === "tkc" ? children : <Navigate to="/" replace />);
const HakedisRoute = () => (getCompany() === "tkc" ? <Navigate to="/sozlesmeler" replace /> : <ProgressPayments />);
const Gate = () => (sessionStorage.getItem("entered") ? <Layout /> : <Navigate to="/giris" replace />);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/giris" element={<Landing />} />
          <Route element={<Gate />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/projeler" element={<Projects />} />
            <Route path="/is-kalemleri" element={<WorkItems />} />
            <Route path="/kesif" element={<Discovery />} />
            <Route path="/santiye-gunlugu" element={<SiteLogs />} />
            <Route path="/puantaj" element={<Puantaj />} />
            <Route path="/malzeme-talepleri" element={<MaterialRequests />} />
            <Route path="/malzeme-hareketleri" element={<MaterialMovements />} />
            <Route path="/hakedis" element={<HakedisRoute />} />
            <Route path="/belgeler" element={<Documents />} />
            <Route path="/firmalar" element={<Firms />} />
            <Route path="/analiz" element={<Analytics />} />
            <Route path="/veri-aktarimi" element={<DataImport />} />
            <Route path="/kalem-esleme" element={<ItemMatching />} />
            <Route path="/kesintiler" element={<Deductions />} />
            <Route path="/sozlesmeler" element={<TkcOnly><Contracts /></TkcOnly>} />
            <Route path="/sozlesmeler/:id" element={<TkcOnly><ContractDetail /></TkcOnly>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
